import {
  LOCATIONS_INDEX_REQUESTED,
  LOCATIONS_INDEX_SUCCESS,
  LOCATIONS_INDEX_FAILURE,
  CORPORATE_LOCATION_CREATE_REQUESTED,
  CORPORATE_LOCATION_CREATE_SUCCESS,
  CORPORATE_LOCATION_CREATE_FAILURE,
  CORPORATE_LOCATION_UPDATE_REQUESTED,
  CORPORATE_LOCATION_UPDATE_SUCCESS,
  CORPORATE_LOCATION_UPDATE_FAILURE,
  CORPORATE_LOCATION_DELETE_REQUESTED,
  CORPORATE_LOCATION_DELETE_SUCCESS,
  CORPORATE_LOCATION_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  locations: [],
  errors: null
};

const locations = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case LOCATIONS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        locations: [],
        status: 'requesting',
        errors: null,
      });

    case LOCATIONS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        locations: action.payload.locations,
        errors: null
      });

    case LOCATIONS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        locations: [],
        errors: 'error here'
      });

    case CORPORATE_LOCATION_CREATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case CORPORATE_LOCATION_CREATE_SUCCESS:
      newState.isUpdating = false;
      newState.locations.push(action.location.location);
      return newState;

    case CORPORATE_LOCATION_CREATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to create corporate address';
      return newState;


    case CORPORATE_LOCATION_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case CORPORATE_LOCATION_UPDATE_SUCCESS:
      newState.isUpdating = false;
      let toUpdate = newState.locations.findIndex(address => address.id === action.location.address.id)
      newState.locations[toUpdate] = action.location.address;
      return newState;

    case CORPORATE_LOCATION_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to update corporate address';
      return newState;


    case CORPORATE_LOCATION_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.locations = newState.locations.filter(address => address.id !== action.addressId);
      newState.errors = null;
      return newState;

    case CORPORATE_LOCATION_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case CORPORATE_LOCATION_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to delete corporate address';
      return newState;


    default:
      return state;
  }
}

export default locations;